<template>
  <div class="default-content loadingAni" :class="isMobile ? 'fd-mobile' : 'fd-not-mobile'" id="defaultContent"
    ref="defaultContent">
    <div class="book-wrapper" :class="{ mobile: isMobile }" v-singletap="clickTabNav">
      <EditDefault></EditDefault>
      <Book refs="fdbook" @get-exceed="getExceed"></Book>
    </div>
    <BookFooter @getShowSK="getShowSK"></BookFooter>
    <transition name="fade">
      <Loading v-if="loadingShow"></Loading>
    </transition>
    <SearchKeys v-show="isShowSK && isMobile" @closenow="closenow"></SearchKeys>
    <StreamTip v-if="streamTipShow"></StreamTip>
  </div>
</template>
<script>
import Book from '@views/Book.vue'
import EditDefault from '@components/editDrawer/Default.vue'
import BookFooter from '@components/books/bookFooter.vue'
import Loading from '@components/books/loading'
import SearchKeys from '@components/searchKeys'
import StreamTip from '@components/books/components/streamTip'

export default {
  name: 'Defaults',
  data() {
    return {
      loadingShow: true,
      loadingTimer: null,
      isShowSK: false,
      streamTipShow: false,
      tiptimer: null,
      isExceed: false // 流量是否超额
    }
  },
  watch: {},
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    },
    isShowFooter() {
      return this.$store.state.book.isShowFooter
    },
    isShowTitle() {
      return this.$store.state.book.isShowTitle
    },
    timer() {
      return this.$store.state.book.timer
    },
    bookPath() {
      return this.$store.state.book.bookPath
    },
    isContent() {
      return this.$route.path.indexOf('content') > -1
    }
  },
  components: {
    Book,
    BookFooter,
    Loading,
    SearchKeys,
    EditDefault,
    StreamTip
  },
  methods: {
    clickTabNav(e) {
      if (this.isMobile && e.type === 'singletap' && e.target.className.indexOf('fd-js-excludes') < 0) {
        clearTimeout(this.timer)
        this.$store.commit('book/UPDATE_IS_SHOW_FOOTER', !this.isShowFooter)
        this.$store.commit('book/UPDATE_IS_SHOW_TITLE', !this.isShowTitle)
      }
    },
    closenow() {
      this.isShowSK = false
      this.$store.commit('book/UPDATE_IS_SHOW_FOOTER', true)
      this.$store.commit('book/UPDATE_IS_SHOW_TITLE', true)
    },
    getShowSK() {
      this.isShowSK = true
      this.$store.commit('book/UPDATE_IS_SHOW_FOOTER', false)
      this.$store.commit('book/UPDATE_IS_SHOW_TITLE', false)
    },
    isShowStreamTip() {
      if (this.bookPath === 'nobook') {
        return
      }
      if (this.isMobile) {
        // 移动端
        if (localStorage.getItem('streamTipMobile')) {
          this.$store.commit('book/UPDATE_IS_SHOW_PHONE_STREAM_TIP', false)
        } else {
          localStorage.setItem('streamTipMobile', 'stream-tip-mobile')
          this.$store.commit('book/UPDATE_IS_SHOW_PHONE_STREAM_TIP', true)
        }
      } else {
        // pc端
        if (localStorage.getItem('streamTip')) {
          this.$store.commit('book/UPDATE_IS_SHOW_STREAM_TIP', false)
        } else {
          localStorage.setItem('streamTip', 'stream-tip')
          this.$store.commit('book/UPDATE_IS_SHOW_STREAM_TIP', true)
        }
      }
    },
    getExceed(value) {
      this.isExceed = value
    }
  },
  mounted() {
    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer)
    }
    console.log(this.$route, this.$route.path.indexOf('content'), this.$route.path.indexOf('content2'))
    this.loadingTimer = setTimeout(() => {
      this.loadingShow = false
      this.isShowStreamTip()
    }, 1500)
  },
  destroyed() {
    clearTimeout(this.loadingTimer)
  }
}
</script>
<style lang="scss">
.default-content {
  background: #f4f4f4;
  display: flex;
  flex-direction: column;
  flex: 1;
  cursor: default;

  &.fd-mobile {
    height: 100%;
  }

  .book-wrapper {
    display: flex;
    flex: 1;
    padding-bottom: 40px;

    &.mobile {
      height: 100%;
      padding-bottom: 0;
      position: relative;
    }
  }
}

.loadingAni {

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
